<template>
  <div>
    <TreeSelector
      v-on="$listeners"
      v-bind="$attrs"
      :lazy="lazy"
      :load="load"
      :data="innerData"
      :multiple="multiple"
      :mustLeaf="mustLeaf"
      :filterable="filterable"
      :props="props"
      :size="size"
      :disabled="disabled"
      :remoteFilter="remoteFilter"
      :selectedKeys="selectedKeys"
      :selectedData="selectedData"
      :popperWidth="popperWidth"
      @change="change"
    ></TreeSelector>
  </div>
</template>

<script>
import apis from './api.js'
import { componentMessage } from '../utils'
import response from '../../../utils/response'
import TreeSelector from '../../basis/tree-selector'

export default {
  name: 'budget-subject-tree-selector',
  components: {
    TreeSelector
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    // lazy 时候需要传load属性, false时默认加载全量数据
    lazy: {
      type: Boolean,
      default: true
    },
    // 是否多选
    multiple: {
      type: Boolean, 
      default: false
    },
    // 是否只有叶子节点可选
    mustLeaf: {
      type: Boolean, 
      default: true
    },
    // 是否可进行搜索，如果需要远程搜索，配合`remoteFilter`使用，如果不设置`remoteFilter`，则会走默认本地搜索逻辑；
    filterable: {
      type: Boolean, 
      default: true
    },
    // 初始选中的节点的key集合
    selectedKeys: {
      type: Array, 
      default: () => []
    },
    // 需要配合selectedIds使用，并且两者一一对应；
    // 用于有初始数据+懒加载的场景，因为懒加载时有些初始的数据没法获取其label，`selectedData`用来指定每个id对应的label;
    // [{key: '', label: ''}]， 数组元素的键值是根据`props`来的；
    selectedData: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: 'mini'
    },
    props: {
      type: Object,
      default: {
        label: 'name',
        key: 'code',
        children: 'children',
        isLeaf: 'isLeaf'
      }
    },
    popperWidth: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      innerData: [],
      nodes: [],
      componentMessage
    }
  },
  created () {
    let flag = this.componentMessage(['mall', 'purchaser'], 'budget-subject-tree-selector 预算科目')
    if (flag) return
  },
  methods: {
    change(val) {
      let data = []
      if (val.selectedData) {
        val.selectedData.forEach(ele => {
          let item = this.nodes.find(it => it[this.props.key] === ele[this.props.key])
          data.push(item)
        })
      }
      if (data.length === val.selectedData.length) {
        this.$set(val, 'selectedData', data)
      }
      this.$emit("change", val)
      console.log(val, 'change')
    },
    async load (node, resolve) {
      let api = apis.getBudgetSubject
      const res = await response(this.$http(api.type, api.url, {
        id: node.level === 0 ? null : node.data.id
      }), {
        loadingOptions: false
      })
      if (res.isOk && res.content && Array.isArray(res.content)) {
        res.content.forEach((item, index) => {
          this.$set(item, 'isLeaf', item.leafFlag === 1)
        })
        resolve(res.content)
      }
    },
    // 筛选
    async remoteFilter (queryString) {
      if (!queryString) {
        return []
      }
      let api = apis.remoteFilter
      let res = await response(this.$http(api.type, api.url, {
        searchKey: queryString
      }))
      if (res.isOk && res.content && Array.isArray(res.content)) {
        this.nodes = res.content.map(item => {
          return {
            ...item,
            key: item[this.props.key],
            label: item[this.props.label]
          }
        })
        return this.nodes
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scope>
</style>
